import React, { Fragment } from "react";
import Typography from "@material-ui/core/Typography";
import Paper from "@material-ui/core/Paper";
import useTagValueSelector from "../tags-manager/tag-values-selector";

const TestPage = () => {
  const { Component, state } = useTagValueSelector();
  console.log({ state });
  return (
    <Fragment>
      <Typography variant="h5" component="h3">
        TestPage
      </Typography>
      <Paper>
        <Component />
      </Paper>
    </Fragment>
  );
};

export default TestPage;



// WEBPACK FOOTER //
// ./src/components/test-page/index.js